import { NgModule, Inject } from '@angular/core';
import { Routes, RouterModule, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AppComponent } from './app.component';
import { SuggestDiagnosisComponent } from './suggest-diagnosis/suggest-diagnosis.component';
import { DiagnosisResultsComponent } from './diagnosis-results/diagnosis-results.component';
import { DiagnosisResultsResolver } from './resolvers/diagnosis-results-resolver';
// import { WhereToGoToolComponent } from './where-to-go-tool/where-to-go-tool.component';
import {  DOCUMENT } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { SuggestDiagnosisService } from './services/suggest-diagnosis.service';

const routes: Routes = [
  {
    path: 'suggest-diagnosis',
    children: [
      {
        path: '',
        component: SuggestDiagnosisComponent
      },
      {
        path: ':age/:gender/:region/:pregnant/:symptoms',
        component: SuggestDiagnosisComponent
        // resolve: {diagnosiseResults: DiagnosisResultsResolver}
      }
    ]
  },
  // { path: 'where-to-go-tool', component: WhereToGoToolComponent },

  { path: '', redirectTo: '/suggest-diagnosis', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {
  currentPage: any;
  currentSearchState: any;
  ensightenEnv: any;

  constructor(private router: Router,
    private ActRoute: ActivatedRoute,
    @Inject(DOCUMENT) private document: any,
    private SuggestDiagnosisService: SuggestDiagnosisService,
  ) {
    // Ensighten Bootstrap Script loading
    const script = this.document.createElement('script');
    const ensightenURL = 'https://nexus.ensighten.com/bcbsal/';
    if (environment.envName === 'devserver' || environment.envName === 'local') {
      this.ensightenEnv = environment.EnsightenEnv;
    }else if (environment.envName === 'qa') {
      if (window.location.host === 'www.bcbsal.org') {
        this.ensightenEnv = 'bcbsal_prod';
      }else if(window.location.host === 'fl.exploremyplan.com'){
         this.ensightenEnv = 'bpi_prod';
      } else {
        this.ensightenEnv = environment.EnsightenEnv;
      }
    }
    script.src = ensightenURL + this.ensightenEnv + '/Bootstrap.js';
    this.document.getElementsByTagName('head')[0].appendChild(script);

    // navigation events for google analytics
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        const routeParams = this.splitString(val.url, '/');
        const queryParams = this.splitString(val.url, '&');
        if (val.url === '/') {
          this.currentPage = 'BASIC INFO';
          this.currentSearchState = null;
        } else if (routeParams[1] === 'suggest-diagnosis') {
          this.currentPage = 'DIAGNOSIS';
          this.currentSearchState = {
              age: routeParams[2],
              gender: routeParams[3],
              region : routeParams[4],
              pregnant: routeParams[5],
              symptoms: routeParams[6]
          };
        } else if (queryParams[0]) {
          if (queryParams[0].indexOf('where-to-go-tool') > 0) {
            this.currentPage = 'WHERE TO GO TOOL';
            this.currentSearchState = null;
          }
        }
        this.SuggestDiagnosisService.onTriggerTrackingEvent(this.currentPage, this.currentSearchState);
      }
    });
  }
  public splitString(stringToSplit, separator) {
    const arrayOfStrings = stringToSplit.split(separator);
    return arrayOfStrings;
  }
  public parseWhereNowUrl(url) {
    const whereNowURLTree = this.router.parseUrl(url);
    return {
      age: whereNowURLTree.queryParams.age,
      dx: whereNowURLTree.queryParams.dx,
      pregnancy: whereNowURLTree.queryParams.pregnancy,
      region: whereNowURLTree.queryParams.region,
      sex: whereNowURLTree.queryParams.sex,
      text: whereNowURLTree.queryParams.text
    };
  }

  public msieversion() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    // If Internet Explorer, return version number
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      console.log('IE Browser');
      return false;
    } else {
      // If another browser, return 0
      console.log('otherbrowser');
      return true;
    }
  }
}

export const routedComponents = [AppComponent];

// imports: [RouterModule.forRoot(routes, { useHash: true })]



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts